import { Box } from '@mui/material';
import { DeliveryDateType, getDeliveryDateTypeShortTranslationId } from '@synergy/models';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { ReactElement } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface PaloDeliveryDateValueProps {
    date?: Date | string | null;
    type?: DeliveryDateType;
    /** Struck through, for an order that will not be delivered. */
    void?: boolean;
}

/**
 * A delivery date in a list cell, with its kind in one word before it — "bis
 * 12. Okt. 2026", "fix 14. Okt. 2026". Without a date, a dash (#2267).
 */
export const PaloDeliveryDateValue = ({ date, type, void: isVoid }: PaloDeliveryDateValueProps): ReactElement => {
    if (!date) {
        return <>–</>;
    }

    return (
        <Box component="span" sx={{ textDecoration: isVoid ? 'line-through' : undefined, whiteSpace: 'nowrap' }}>
            <Box component="span" sx={{ color: tokens.color.ink3, mr: '4px' }}>
                <FormattedMessage id={getDeliveryDateTypeShortTranslationId(type)} />
            </Box>
            <FormattedDate value={date} year="numeric" month="short" day="2-digit" />
        </Box>
    );
};
